/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type TuberculosisHistoryDtoPreviousTuberculinTest =
  (typeof TuberculosisHistoryDtoPreviousTuberculinTest)[keyof typeof TuberculosisHistoryDtoPreviousTuberculinTest];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TuberculosisHistoryDtoPreviousTuberculinTest = {
  YES: 'YES',
  NO: 'NO',
  UNKNOWN: 'UNKNOWN',
} as const;
